<template>
    <div>
        <div class="row">
            <div class="col-lg-8">
                <h4 v-if="admon">Cuenta Administración <br><b>{{ cta.user }} </b></h4>
                <h4 v-else>Información personal</h4>

                <b-form @submit.prevent="submit" v-show="!admon">
                    <div class="form-row">
                        <b-form-group label="Sr/Sra." class="col-6 col-sm-2">
                            <b-form-select v-model="cta.sra" class="mr-1">
                                <b-form-select-option value='0'>Sr.</b-form-select-option>
                                <b-form-select-option value='1'>Sra.</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label="Nombre de Usuario / Alias" class="col-6 col-sm-10">
                            <b-form-input v-model="cta.name" required trim></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="form-row">
                        <b-form-group label="Apellidos" class="col-12 col-sm-7">
                            <b-form-input v-model="cta.ape" v-uppercase required trim></b-form-input>
                        </b-form-group>
                        <b-form-group label="Nombre" class="col-12 col-sm-5">
                            <b-form-input v-model="cta.nom" v-uppercase required trim></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="form-row">
                        <b-form-group label="DNI/NIF" class="col-12 col-sm-6">
                            <b-form-input v-model="cta.nif" ref='dni' required trim @blur="valida_dni"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Año Nacimiento" class="col-6 col-sm-3">
                            <b-form-input v-model="cta.nac" required trim></b-form-input>
                        </b-form-group>
                        <b-form-group label="Cod.Postal" class="col-6 col-sm-3">
                            <b-form-input v-model="cta.cpo" required trim></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="form-row">
                        <b-form-group label="Localidad de Residencia" class="col-12 col-sm-7">
                            <b-form-input v-model="cta.pob" v-uppercase required trim></b-form-input>
                        </b-form-group>
                        <b-form-group label="Provincia" class="col-12 col-sm-5">
                            <b-form-input v-model="cta.pro" v-uppercase trim></b-form-input>
                        </b-form-group>
                    </div>
                    <hr>
                    <div class="d-flex mt-3">
                        <h5>Datos Contacto / Acceso</h5>
                        <!-- <small class="ml-auto">*Datos Obligatorios</small> -->
                    </div>

                     <div class="form-row">
                        <!-- <b-form-group label="Teléfono Movil" class="col-sm-4">                             -->
                            <b-input-group class="my-1 col-12 col-sm-4">
                                <b-input-group-prepend is-text>
                                    <b-icon-telephone-fill/>
                                </b-input-group-prepend>
                                <b-form-input v-model="cta.tfno" disabled></b-form-input>
                            </b-input-group>
                        <!-- </b-form-group>            -->
                        <!-- <b-form-group label="eMAIL" class="col-sm-8">                             -->
                            <b-input-group class="my-1 col-12 col-sm-8">
                                <b-input-group-prepend is-text>
                                    <b-icon-envelope/>
                                </b-input-group-prepend>
                                <b-form-input v-model="cta.email" disabled></b-form-input>
                            </b-input-group>
                        <!-- </b-form-group>                                    -->
                    </div>

                    <hr>
                    <!-- <b-button block variant="success" @click="enviar">ENVIAR</b-button> -->
                    <b-button type="submit" block variant="success">
                        Modificar DATOS
                    </b-button>
                </b-form>

            </div>
<!-- Informacion Derecha -->
            <div class="col-lg-4 mt-4 mt-lg-0">
                <div class="bg-light-2 p-3">
                    <p class="mb-2">Importante completar</p>
                    <p class="small">En caso de reservas con más de una persona es imprescindible
                        rellenar el DNI de todos y cada uno de los viajeros.</p>
                    <hr>
                    <p class="mb-2">Mensajes de alertas</p>
                    <p class="small">Aquí se pueden mostrar alertas u otros mensajes de interés para
                        el usuario. </p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'cuenta',
    components: {
        //publicidad,
    },
    data() {
        return {
            submitted: false,
            message: 'Error',
        };
    },
    computed: {
        ...mapState(['auth','errores']),
        ...mapState('G',['url']),

        cta() {
            return this.auth.user;
        },
        admon() {
            return (this.cta.dep=='ADMON');
        },
        chk_selected() {
            return this.submitted && !this.reg.chk;
        }
    },
    methods: {
        ...mapMutations(['loading','alerta','modal','showModal']),
        ...mapActions(['exec']),

        submit(evt) {
            evt.preventDefault();

            //controlar errores
            this.submitted=true;
            //enviar
            this.enviar();
        },
        async enviar() {
            //this.loading();

            var args=this.cta;
            args.token=this.auth.token;
            let r=await this.exec({api:'info_personal', arg: args });

            let msg=r.error ? r.datos : 'Datos Guardados correctamente';
            //this.$store.commit('modal','Información Personal',msg);
            this.modal({tit:"Información Personal", msg:msg});

            this.submitted=false;
            //this.loading(false);

            //this.$router.push('/');
        },
        //validar
        valida_dni() {
            let r=this.$util.validaCIF(this.auth.user.nif);
            if (!r) {
                this.$refs.dni.focus();
                alert('Invalido ' + r);
            }
        },

    },
}
</script>
